module.exports = "<!--<i [class]=\"glyphClass\" (mousedown)=\"onMouseDown($event)\" (mouseup)=\"onMouseUp($event)\" (mousemove)=\"onMouseMove($event)\"></i>-->\r\n<div *ngIf=\"mouseDown\" class=\"overlay\" [style.cursor]=\"cursor\"></div>\r\n<i #glyph [class]=\"cssClass\">\r\n    <span #glyphChild *ngIf=\"direction == 1 || direction == 2\"></span>\r\n</i>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/resize-glyph/resize-glyph.component.html
// module id = ./src/app/resize-glyph/resize-glyph.component.html
// module chunks = main